import { SelectFieldOption } from '@resurs-internal/mui/components/SelectField/SelectFieldOption';
import { useMemo } from 'react';

import useSettings from '../../hooks/useSettings';
import useTranslation from '../../hooks/useTranslation';
import RadioField from '../RadioField/RadioField';

type Props = {
    name: string;
};

const LivingConditionField = ({ name }: Props) => {
    const translate = useTranslation();
    const { countryCode } = useSettings();

    const livingConditionOptionsSE: SelectFieldOption[] = useMemo<SelectFieldOption[]>(
        () => [
            {
                id: 'MARRIED',
                label: translate('field.living-condition.option.married.label'),
            },
            {
                id: 'DOMESTIC_PARTNER',
                label: translate('field.living-condition.option.domestic-partner.label'),
            },
            {
                id: 'SINGLE',
                label: translate('field.living-condition.option.single.label'),
            },
        ],
        [translate],
    );

    const occupationOptionsNO: SelectFieldOption[] = useMemo<SelectFieldOption[]>(
        () => [
            {
                id: 'MARRIED',
                label: translate('field.living-condition.option.married.label'),
            },
            {
                id: 'DOMESTIC_PARTNER',
                label: translate('field.living-condition.option.domestic-partner.label'),
            },
            {
                id: 'SINGLE',
                label: translate('field.living-condition.option.single.label'),
            },
            {
                id: 'DIVORCED',
                label: translate('field.living-condition.option.divorced.label'),
            },
            {
                id: 'WIDOW',
                label: translate('field.living-condition.option.widow.label'),
            },
        ],
        [translate],
    );

    const showOptions = () => {
        switch (countryCode) {
            case 'NO':
                return occupationOptionsNO;
            case 'SE':
                return livingConditionOptionsSE;
            default:
                return livingConditionOptionsSE;
        }
    };

    return <RadioField name={name} options={showOptions()} />;
};

export default LivingConditionField;
